import React from "react";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Select } from "antd";
import CustomChip from "../../general/chips";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

const Option = Select.Option;

const ListFilters = props => {
  const {
    filters,
    myType,
    filtersNotChange,
    onFiltersChange,
    requestsLength
  } = props;

  const company = useSelector(state => state.company);
  const surveys = useSelector(state => state.ask.surveys);
  const drafts = useSelector(state => state.ask.drafts);

  const intl = useIntl();

  function renderCompanies() {
    let listOpts = [
      <Option key={"select_list_company_all"} value={""}>
        <FormattedMessage id="ask.pages.list.allCustomers" />
      </Option>
    ];
    company.companies.map(comp => {
      if (comp.accountant !== true && comp.company !== false) {
        listOpts.push(<Option key={"select_list_company_" + comp.uuid} value={comp.uuid}>
          {comp.ragioneSociale}
        </Option>);
      }
      return null;
    });
    return listOpts;
  }

  function calcTotals(type) {
    let listToCheck = surveys.list.concat(drafts.list);
    let value = 0;
    if (type === "toRead") {
      if (filters.company !== "") {
        listToCheck.map(survey => {
          if (
            survey.itemId === filters.company &&
                        !survey.managerViewedAt &&
                        survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      } else {
        listToCheck.map(survey => {
          if (
            !survey.managerViewedAt &&
                        survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      }
    } else if (type === "toSend") {
      if (filters.company !== "") {
        listToCheck.map(survey => {
          if (
            survey.itemId === filters.company &&
                        !survey.itemId &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      } else {
        listToCheck.map(survey => {
          if (
            !survey.itemId &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      }
    } else if (type === "toFill") {
      if (filters.company !== "") {
        listToCheck.map(survey => {
          if (
            survey.itemId === filters.company &&
                        survey.itemId &&
                        survey.createdAt &&
                        !survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      } else {
        listToCheck.map(survey => {
          if (
            survey.itemId && survey.createdAt &&
                        !survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      }
    } else if (type === "filled") {
      if (filters.company !== "") {
        listToCheck.map(survey => {
          if (
            survey.itemId === filters.company &&
                        survey.createdAt &&
                        survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      } else {
        listToCheck.map(survey => {
          if (
            survey.createdAt &&
                        survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      }
    } else if (type === "itemToRead") {
      if (filters.company !== "") {
        surveys.list.map(survey => {
          if (
            survey.itemId === filters.company &&
                        !survey.itemViewedAt &&
                        !survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      } else {
        surveys.list.map(survey => {
          if (
            !survey.itemViewedAt &&
                        !survey.completedAt &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      }
    } else {
      if (filters.company !== "") {
        listToCheck.map(survey => {
          if (
            survey.itemId === filters.company &&
                        (filters.title === "" ||
                            survey.title
                              .toLowerCase()
                              .indexOf(filters.title.toLowerCase()) > -1)
          ) {
            value++;
          }
          return null;
        });
      } else {
        listToCheck.map(survey => {
          if (
            filters.title === "" ||
                        survey.title
                          .toLowerCase()
                          .indexOf(filters.title.toLowerCase()) > -1
          ) {
            value++;
          }
          return null;
        });
      }
    }
    return value;
  }

  return (
    <div>
      {(requestsLength > 0 || (requestsLength === 0 && !filtersNotChange(filters))) && (
        <div className="askList-search">
          <div className={myType === "STUDIO" && "askList-search-filters"} style={myType !== "STUDIO" ? { width: "100%", marginTop: 20 } : {}}>
            <Input
              className="askList-search-input"
              placeholder={intl.formatMessage({id: "ask.searchPlaceholder"})}
              suffix={
                <Button>
                  <FontAwesomeIcon icon={["far", "search"]} />
                </Button>
              }
              onChange={e => {
                onFiltersChange({ ...filters, title: e.target.value });
              }}
            />
          </div>
          {myType === "STUDIO" && <div className="askList-search-filters">
            <Select
              value={filters.company}
              size="large"
              onChange={value =>
                onFiltersChange({ ...filters, company: value })
              }
              style={{ width: "100%" }}
            >
              {renderCompanies()}
            </Select>
          </div>}
        </div>
      )}
      {calcTotals("all") > 0 && (
        <div className="askList-filters">
          {myType === "STUDIO" ? <div className="askList-filters-chips">
            <CustomChip
              active={filters.type === ""}
              onClick={() =>
                onFiltersChange({ ...filters, type: "" })
              }
              description={`${intl.formatMessage({ id: "ask.pages.list.all"})} ${calcTotals("all")}`}
            />
            <CustomChip
              active={
                filters.type === "toSend"
              }
              onClick={() =>
                onFiltersChange({ ...filters, type: "toSend" })
              }
              description={`${intl.formatMessage({ id: "ask.pages.list.toSend"})} ${calcTotals("toSend")}`}
            />
            <CustomChip
              active={
                filters.type === "toFill"
              }
              onClick={() =>
                onFiltersChange({ ...filters, type: "toFill" })
              }
              description={`${intl.formatMessage({ id: "ask.pages.list.toFill"})} ${calcTotals("toFill")}`}
            />
            <CustomChip
              active={
                filters.type === "filled"
              }
              onClick={() =>
                onFiltersChange({ ...filters, type: "filled" })
              }
              description={`${intl.formatMessage({ id: "ask.pages.list.filled"})} ${calcTotals("filled")}`}
            />
            <CustomChip
              active={
                filters.type === "toRead"
              }
              onClick={() =>
                onFiltersChange({ ...filters, type: "toRead" })
              }
              description={`${intl.formatMessage({ id: "ask.pages.list.toRead"})} ${calcTotals("toRead")}`}
            />
          </div> :
            <div className="askList-filters-chips">
              <CustomChip
                active={filters.type === "" }
                onClick={() =>
                  onFiltersChange({ ...filters, type: "" })
                }
                description={`${intl.formatMessage({ id: "ask.pages.list.all"})} ${calcTotals("all")}`}
              />
              <CustomChip
                active={filters.type === "itemToRead"}
                onClick={() =>
                  onFiltersChange({ ...filters, type: "itemToRead" })
                }
                description={`${intl.formatMessage({ id: "ask.pages.list.toRead"})} ${calcTotals("itemToRead")}`}
              />
              <CustomChip
                active={filters.type === "toFill"}
                onClick={() =>
                  onFiltersChange({ ...filters, type: "toFill" })
                }
                description={`${intl.formatMessage({ id: "ask.pages.list.toFill"})} ${calcTotals("toFill")}`}
              />
            </div>}
          <div className="askList-filters-date">
            <Select
              value={filters && filters.sort.field}
              size="large"
              onChange={value =>
                onFiltersChange({
                  ...filters,
                  sort: {
                    field: value,
                    direction: filters.sort.direction
                  }
                })
              }
              style={{ width: 182 }}
            >
              <Option key={"createdAt"} value="createdAt">
                {myType === "STUDIO" ? intl.formatMessage({ id: "ask.pages.list.sendDate"}) : intl.formatMessage({ id: "ask.pages.list.requestDate"})}
              </Option>
              <Option key={"completedAt"} value="completedAt">
                {myType === "STUDIO" ? intl.formatMessage({ id: "ask.pages.list.fillDate"}) : intl.formatMessage({ id: "ask.pages.list.sendDate"})}
              </Option>
              <Option key={"remindedAt"} value="remindedAt">
                {intl.formatMessage({ id: "ask.pages.list.solicitDate"})}
              </Option>
            </Select>
            <div
              className="askList-filters-date-icon"
              onClick={() =>
                onFiltersChange({
                  ...filters,
                  sort: {
                    field: filters.sort.field,
                    direction:
                                            filters.sort.direction === "desc"
                                              ? "asc"
                                              : "desc"
                  }
                })
              }
              style={{
                cursor: "pointer",
                paddingLeft: 10,
                paddingRight: 10
              }}
            >
              <FontAwesomeIcon
                icon={[
                  "far",
                  filters.sort.direction === "desc"
                    ? "long-arrow-down"
                    : "long-arrow-up"
                ]}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListFilters;
